import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=1d54aa20&scoped=true&"
import script from "./salon.vue?vue&type=script&lang=js&"
export * from "./salon.vue?vue&type=script&lang=js&"
import style0 from "./salon.vue?vue&type=style&index=0&id=1d54aa20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54aa20",
  null
  
)

export default component.exports